import { useState } from 'react';

// ** MUI Imports
import Accordion from '@mui/material/Accordion'
import Typography from '@mui/material/Typography'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Box from '@mui/material/Box'

// ** Icons Imports
import ChevronDown from 'mdi-material-ui/ChevronDown'

type Props = {
    title: string,
    index: number,
    children: React.ReactNode
}

const GroupItem = ({ children, title, index }: Props) => {
    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    return (
        <Accordion expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
            <AccordionSummary expandIcon={<ChevronDown />} aria-controls={`panel-content-${index}`} id={`panel-header-${index}`}>
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {expanded === `panel${index}` && children}
            </AccordionDetails>
        </Accordion>
    )
}

export { GroupItem }

export default GroupItem;